import AddButton from "./AddButton"
import RefreshButton from "./RefreshButton"

export { AddButton, RefreshButton as Refresh }

export default function DefaultActions({ refresh = <RefreshButton />, add = <AddButton />, children }) {
  return <Wrapper>
    {refresh}
    {children}
    {add}
  </Wrapper>
}

export function Wrapper({ children }) {
  return <div className="flex gap-4">
    {children}
  </div>
}

